import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "./EmployeeTestimonials.css";
import { FaUserGraduate } from "react-icons/fa6";

const EmployeeTestimonials = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  const testimonials = [
    {
      id: 1,
      name: "Aditya Kumar Nath",
      position: "Senior Full Stack Developer / UI/UX Developer",
      image: "https://randomuser.me/api/portraits/men/1.jpg",
      text: "Working at MK E-Tech has been transformative for my career. The innovative projects and supportive team environment make it an ideal workplace for any software professional.",
    },
    {
      id: 2,
      name: "Mahesh Autade",
      position: "Full Stack Developer",
      image: "https://randomuser.me/api/portraits/men/2.jpg",
      text: "The culture of excellence and continuous learning at MK E-Tech is remarkable. I've grown both personally and professionally in my time here.",
    },
    {
      id: 3,
      name: "Vivek Kshirsagar",
      position: "Web Developer",
      image: "https://randomuser.me/api/portraits/men/3.jpg",
      text: "As a designer, I appreciate how MK E-Tech values user experience and invests in cutting-edge tools. Our work truly makes a difference for our clients.",
    },
    {
      id: 4,
      name: "Saif Khan",
      position: "DevOps Engineer",
      image: "https://randomuser.me/api/portraits/men/4.jpg",
      text: "The technical challenges we solve at MK E-Tech keep me engaged and constantly learning. It's rewarding to be part of such a dynamic team.",
    },
    {
      id: 5,
      name: "Simran Singh",
      position: "Data Scientist",
      image: "https://randomuser.me/api/portraits/women/1.jpg",
      text: "The data-driven approach at MK E-Tech allows us to create truly impactful solutions. I'm proud of the work we do and the problems we solve.",
    },
    {
      id: 6,
      name: "Puja Pawar",
      position: "QA Lead",
      image: "https://randomuser.me/api/portraits/women/2.jpg",
      text: "Quality is at the heart of everything we do at MK E-Tech. Our commitment to excellence ensures we deliver the best products to our clients.",
    },
    {
      id: 7,
      name: "Priya Sharma",
      position: "Frontend Developer",
      image: "https://randomuser.me/api/portraits/women/3.jpg",
      text: "MK E-Tech provides the perfect environment for creative developers. I love how we're encouraged to experiment with new technologies while building robust applications.",
    },
    {
      id: 8,
      name: "Raj Patel",
      position: "Backend Engineer",
      image: "https://randomuser.me/api/portraits/men/5.jpg",
      text: "The backend architecture challenges at MK E-Tech have helped me grow as an engineer. Our team's collaborative approach ensures we deliver scalable solutions.",
    },
    {
      id: 9,
      name: "Ananya Singh",
      position: "AI/ML Specialist",
      image: "https://randomuser.me/api/portraits/women/4.jpg",
      text: "Working with cutting-edge AI technologies at MK E-Tech has been incredibly rewarding. The company truly values innovation and research-driven development.",
    },
    {
      id: 10,
      name: "Vikram Malhotra",
      position: "Cloud Architect",
      image: "https://randomuser.me/api/portraits/men/6.jpg",
      text: "MK E-Tech's cloud-first approach has allowed me to design solutions that are both scalable and cost-effective. The trust in technical expertise here is exceptional.",
    },
    {
      id: 11,
      name: "Sunita Reddy",
      position: "Project Manager",
      image: "https://randomuser.me/api/portraits/women/5.jpg",
      text: "The project management methodologies at MK E-Tech strike the perfect balance between structure and flexibility. Delivering value to clients is always our top priority.",
    },
    {
      id: 12,
      name: "Arjun Kumar",
      position: "Mobile Developer",
      image: "https://randomuser.me/api/portraits/men/7.jpg",
      text: "Building cross-platform mobile applications at MK E-Tech has been an amazing experience. We follow best practices while pushing the boundaries of what's possible.",
    },
    {
      id: 13,
      name: "Neha Gupta",
      position: "Database Administrator",
      image: "https://randomuser.me/api/portraits/women/6.jpg",
      text: "Data integrity and performance are paramount at MK E-Tech. I'm proud of how we maintain and optimize our databases to support business critical applications.",
    },
    {
      id: 14,
      name: "Rahul Desai",
      position: "Security Analyst",
      image: "https://randomuser.me/api/portraits/men/8.jpg",
      text: "Security is integrated into every aspect of development at MK E-Tech. I appreciate how proactive we are in identifying and addressing potential vulnerabilities.",
    },
    {
      id: 15,
      name: "Divya Mehta",
      position: "Technical Writer",
      image: "https://randomuser.me/api/portraits/women/7.jpg",
      text: "Clear documentation is valued just as much as clean code at MK E-Tech. I enjoy collaborating with developers to create comprehensive and user-friendly guides.",
    },
    {
      id: 16,
      name: "Sanjay Joshi",
      position: "System Administrator",
      image: "https://randomuser.me/api/portraits/men/9.jpg",
      text: "The infrastructure at MK E-Tech is both robust and flexible. I take pride in ensuring our systems run smoothly to support development teams and clients alike.",
    },
    {
      id: 17,
      name: "Kavita Choudhury",
      position: "Business Analyst",
      image: "https://randomuser.me/api/portraits/women/8.jpg",
      text: "Bridging the gap between client needs and technical solutions is what I love about my role at MK E-Tech. The collaborative environment makes this process seamless.",
    },
    {
      id: 18,
      name: "Amitabh Verma",
      position: "Scrum Master",
      image: "https://randomuser.me/api/portraits/men/10.jpg",
      text: "Agile principles are deeply embedded in MK E-Tech's culture. As a Scrum Master, I facilitate processes that help teams deliver high-quality software iteratively.",
    },
    {
      id: 19,
      name: "Meera Iyer",
      position: "UI/UX Designer",
      image: "https://randomuser.me/api/portraits/women/9.jpg",
      text: "Creating intuitive user interfaces at MK E-Tech has been incredibly fulfilling. Our user-centered design approach ensures we build products that people love to use.",
    },
    {
      id: 20,
      name: "Rohan Kapoor",
      position: "Full Stack Developer",
      image: "https://randomuser.me/api/portraits/men/11.jpg",
      text: "The full-stack development opportunities at MK E-Tech have expanded my skills tremendously. I appreciate working on diverse projects that challenge me technically.",
    },
    {
      id: 21,
      name: "Sneha Menon",
      position: "Data Analyst",
      image: "https://randomuser.me/api/portraits/women/10.jpg",
      text: "Transforming raw data into actionable insights at MK E-Tech is incredibly rewarding. Our data-driven decisions consistently lead to better outcomes for our clients.",
    },
    {
      id: 22,
      name: "Karan Sethi",
      position: "Network Engineer",
      image: "https://randomuser.me/api/portraits/men/12.jpg",
      text: "Building and maintaining robust network infrastructure at MK E-Tech has been a fantastic experience. Reliability and performance are always our top priorities.",
    },
    {
      id: 23,
      name: "Anjali Bhatia",
      position: "Product Owner",
      image: "https://randomuser.me/api/portraits/women/11.jpg",
      text: "Defining product vision and working with development teams at MK E-Tech is a collaborative joy. We consistently deliver features that provide real value to users.",
    },
    {
      id: 24,
      name: "Nikhil Rao",
      position: "Technical Lead",
      image: "https://randomuser.me/api/portraits/men/13.jpg",
      text: "Mentoring developers and guiding technical decisions at MK E-Tech is incredibly fulfilling. Our culture of knowledge sharing makes everyone better at what they do.",
    },
    {
      id: 25,
      name: "Pooja Mehta",
      position: "Software Tester",
      image: "https://randomuser.me/api/portraits/women/12.jpg",
      text: "Ensuring software quality at MK E-Tech is a responsibility I take seriously. Our comprehensive testing processes guarantee that we deliver reliable products every time.",
    },
    {
      id: 26,
      name: "Vishal Nair",
      position: "DevOps Specialist",
      image: "https://randomuser.me/api/portraits/men/14.jpg",
      text: "Automating deployment pipelines and optimizing infrastructure at MK E-Tech has been technically challenging and incredibly rewarding. We enable developers to do their best work.",
    },
    {
      id: 27,
      name: "Shruti Das",
      position: "Content Strategist",
      image: "https://randomuser.me/api/portraits/women/13.jpg",
      text: "Crafting compelling content strategies at MK E-Tech allows me to bridge technical complexity with user understanding. Our content truly helps users get the most from our products.",
    },
    {
      id: 28,
      name: "Aditya Banerjee",
      position: "Solutions Architect",
      image: "https://randomuser.me/api/portraits/men/15.jpg",
      text: "Designing comprehensive technical solutions at MK E-Tech challenges me to think holistically about our clients' needs. I'm proud of the scalable systems we build together.",
    },
    {
      id: 29,
      name: "Deepika Rajan",
      position: "HR Technology Specialist",
      image: "https://randomuser.me/api/portraits/women/14.jpg",
      text: "Implementing HR technology solutions at MK E-Tech has shown me how much the company values its employees. Our internal systems are as well-designed as our client products.",
    },
    {
      id: 30,
      name: "Mohan Krishnan",
      position: "IT Support Lead",
      image: "https://randomuser.me/api/portraits/men/16.jpg",
      text: "Providing exceptional IT support at MK E-Tech means I help colleagues overcome technical challenges daily. Our responsive support system keeps everyone productive and happy.",
    },
    {
      id: 31,
      name: "Aarav Mehta",
      position: "Frontend Architect",
      image: "https://randomuser.me/api/portraits/men/17.jpg",
      text: "Designing scalable frontend architectures at MK E-Tech has been incredibly rewarding. We build systems that are both performant and maintainable.",
    },
    {
      id: 32,
      name: "Ishaani Joshi",
      position: "UX Researcher",
      image: "https://randomuser.me/api/portraits/women/15.jpg",
      text: "Understanding user needs through research at MK E-Tech ensures we build products that truly solve real problems. Our user-centered approach sets us apart.",
    },
    {
      id: 33,
      name: "Rohan Malhotra",
      position: "Backend Architect",
      image: "https://randomuser.me/api/portraits/men/18.jpg",
      text: "Architecting robust backend systems at MK E-Tech challenges me to think about scalability, security, and performance simultaneously.",
    },
    {
      id: 34,
      name: "Sanjana Reddy",
      position: "Product Designer",
      image: "https://randomuser.me/api/portraits/women/16.jpg",
      text: "Crafting beautiful and functional product experiences at MK E-Tech allows me to combine aesthetics with usability in meaningful ways.",
    },
    {
      id: 35,
      name: "Vivek Agarwal",
      position: "Data Engineer",
      image: "https://randomuser.me/api/portraits/men/19.jpg",
      text: "Building data pipelines and infrastructure at MK E-Tech enables our data scientists to derive valuable insights that drive business decisions.",
    },
    {
      id: 36,
      name: "Anika Sharma",
      position: "UX Writer",
      image: "https://randomuser.me/api/portraits/women/17.jpg",
      text: "Crafting clear, concise microcopy at MK E-Tech helps users navigate our products effortlessly. Every word matters in creating great user experiences.",
    },
    {
      id: 37,
      name: "Rohit Deshmukh",
      position: "Site Reliability Engineer",
      image: "https://randomuser.me/api/portraits/men/20.jpg",
      text: "Ensuring system reliability and performance at MK E-Tech is a challenging responsibility that I embrace every day.",
    },
    {
      id: 38,
      name: "Nandini Patel",
      position: "Product Marketing Manager",
      image: "https://randomuser.me/api/portraits/women/18.jpg",
      text: "Bringing our products to market at MK E-Tech allows me to showcase the incredible work our technical teams deliver to customers.",
    },
    {
      id: 39,
      name: "Arnav Singh",
      position: "Technical Project Manager",
      image: "https://randomuser.me/api/portraits/men/21.jpg",
      text: "Managing complex technical projects at MK E-Tech requires balancing scope, timeline, and resources while ensuring quality delivery.",
    },
  ];

  return (
    <div>
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>Employee Testimonials & Tools | Modern Tech Stack</title>
        <meta
          name="description"
          content="Explore employee testimonials and discover the latest tools and technologies including Angular, React Native, Node.js, Laravel, MongoDB, Ethereum, Flutter, AI, Blockchain, IoT, AR/VR and more."
        />
        <meta
          name="keywords"
          content="Employee Testimonials, Tech Stack, Angular, React Native, Node.js, Laravel, MongoDB, Ethereum, Flutter, AI, Artificial Intelligence, Blockchain, Solidity, Hyperledger, IoT, Internet of Things, Augmented Reality, Virtual Reality, PostgreSQL, MySQL, PHP, Django, CodeIgniter, Android Development, iOS Development, SaaS, Salesforce, SQL Server, Oracle, Cloud, Data Science"
        />
      </Helmet>
      <section className="mkEtechTestimonials">
        <div class="mkEtechTeam">
          <div class="mkEtechTeam__text">MK e-Tech Team's</div>
        </div>
        <div className="mkEtechTestimonials__grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="mkEtechTestimonials__card">
              <div className="mkEtechTestimonials__cardInner">
                <div className="mkEtechTestimonials__content">
                  <p className="mkEtechTestimonials__text">
                    {testimonial.text}
                  </p>
                  <div className="mkEtechTestimonials__person">
                    <h3 className="mkEtechTestimonials__name">
                      <span className="main-graduate">
                        <FaUserGraduate className="graduate" />
                      </span>
                      {testimonial.name}
                    </h3>
                    <p className="mkEtechTestimonials__position">
                      {testimonial.position}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeTestimonials;
